import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let sync_id = useDataValue({
    context: 'tab',
    path: 'selected.sync_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { sync_id },
    pause: !sync_id,
  }
}
